import Vue from 'vue'
import VueRouter from 'vue-router'
//import Login from '../components/Login.vue'
//import Reporte1 from '../components/Reporte1.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: require(/* webpackChunkName: "about" */ '../views/Home.vue').default
    //component: Login
  },
  {
    path: '/login',
    name: 'login',
    component: require('../components/Login.vue').default
  },
  {
    path: '/kardexest',
    name: 'kardexest',
    component: require('../components/Kardex_est.vue').default
  },
  {
    path: '/cambiopasest',
    name: 'cambiopasest',
    component: require('../components/Cambiopass.vue').default
  },
  {
    path: '/horarioest',
    name: 'horarioest',
    component: require('../components/Horario_est.vue').default
  },
  {
    path: '/datosest',
    name: 'datosest',
    component: require('../components/Datos_est.vue').default
  },
  {
    path: '/accesomoodle',
    name: 'accesomoodle',
    component: require('../components/Moodle.vue').default
  },
  {
    path: '/congresoestudiante',
    name: 'congresoestudiante',
    component: require('../components/Congreso.vue').default
  },

  {
    path: '/estudiante/qr/',
    name: 'estudianteqr',
    component: require('../components/Estudianteqr.vue').default
  },
  {
    path: '/reglamentos',
    name: 'reglamentos',
    component: require('../components/Reglamentos.vue').default
  },
  {
    path: '/percepcion',
    name: 'percepcion',
    component: require('../components/PercepcionEst.vue').default
  },
  {
    path: '/bibliotecavirtual',
    name: 'bibliotecavirtual',
    component: require('../components/Biblioteca.vue').default
  },
  {
    path: '/inscripcionest',
    name: 'inscripcionest',
    component: require('../components/Inscripcion_est.vue').default
  }
  ,

  {
    path: '/pagoestbol',
    name: 'pagoestbol',
    component: require('../components/PagosBolivianos.vue').default
  },

  {
    path: '/certificadocongreso/:id/:unicodigo',
    name: 'certificadocongreso',
    component: require('../components/CertificadoCongreso.vue').default
  },
  {
    path: '/bolsavirtualdetrabajo',
    name: 'bolsavirtualdetrabajo',
    component: require('../components/BolsaVirtualDeTrabajo.vue').default
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
